<template>
  <div class="index">
    <div class="indexBox">
      <div class="index-top">
        <div class="top-left">
          <div class="top-item">
            <div class="card-title">政策法规库</div>
            <policy-regulatory ref="policyRef"></policy-regulatory>
          </div>
          <div class="top-item">
            <div class="card-title">标准规范</div>
            <standard-specification ref="standardRef"></standard-specification>
          </div>
        </div>
        <div class="top-right" @click="jumpComputed">
          <div class="top-item">
            <div class="card-title">计费计算器</div>
            <img :src="computeImg"/>
          </div>
        </div>
      </div>
      <div class="modelBox clearfix">
        <div class="fl modelLeft">
          <p class="modelTitle">一键生成，智能采购文件模板！</p>
          <p class="modelDesc">高效采购，从此开始！</p>
          <p class="nowUse" @click="getSedToken">立即使用</p>
        </div>
        <div class="fl modelRight">
          <img v-for="(item, index) in imgList" :key="index" :src="item.url" alt=""/>
        </div>
      </div>
      <div class="index-question" style="display: none;">
        <div class="question-item">
          <div class="question-title">
            <img class="hotImg" style="width: 17px;height: 20px;" src="@/assets/images/index/hot.png"/>
            <span>热门搜索</span>
          </div>
          <div class="question-content">
            <popular-searches></popular-searches>
          </div>
        </div>
        <div class="question-item">
          <div class="question-title">
            <img class="hotImg" style="width: 20px;height: 18px;margin-top: 5px;"
                 src="@/assets/images/index/message.png"/>
            <span>最新回答</span>
          </div>
          <div class="question-content">
            <latest-answers></latest-answers>
          </div>
        </div>
        <div class="question-item">
          <div class="question-title">
            <img class="hotImg" style="width: 25px;height: 24px;" src="@/assets/images/index/ai.png"/>
            <span>智能问答</span>
          </div>
          <div class="question-content">
            <intelligent-answers></intelligent-answers>
          </div>
        </div>
      </div>
      <div class="index-center">
        <div class="center-left">
          <div class="center-item">
            <div class="card-title">处罚案例</div>
            <div class="card-content">
              <puishment-demo></puishment-demo>
            </div>
          </div>
        </div>
        <div class="center-right">
          <div class="center-item">
            <div class="card-title">失信名单</div>
            <div class="card-content">
              <dishonesty-name></dishonesty-name>
            </div>
          </div>
        </div>
      </div>
      <tool-box class="mt20" :data="toolList"></tool-box>
      <div class="index-center">
        <div class="center-inline">
          <div class="center-item">
            <div class="card-title">招标公告公示</div>
            <div class="card-content">
              <notice-publicity></notice-publicity>
            </div>
          </div>
        </div>
      </div>
      <video-box></video-box>
      <!-- 会员体验特权到期弹窗 -->
      <tryon-dialog ref="tryon"></tryon-dialog>
    </div>
  </div>
</template>

<script>
import CONFIG_PROJECT from "@config/project";
import swiperBox from "./index/compoentsNew/swiper";
import videoBox from "./index/compoentsNew/video-box";
import toolBox from "./index/compoentsNew/tool-box";
import tryonDialog from "../components/sys/my-header/components/tryon-dialog";

import policyRegulatory from "./index/compoentsNew/policy-regulatory";
import StandardSpecification from "./index/compoentsNew/standard-specification";
import PopularSearches from "./index/compoentsNew/popular-searches";
import LatestAnswers from "./index/compoentsNew/latest-answers";
import IntelligentAnswers from "./index/compoentsNew/intelligent-answers";
import PuishmentDemo from "./index/compoentsNew/puishment-demo";
import DishonestyName from "./index/compoentsNew/dishonesty-name";
import NoticePublicity from "./index/compoentsNew/notice-publicity";


export default {
  head: {
    title: CONFIG_PROJECT.title,
  },
  components: {
    swiperBox,
    videoBox,
    toolBox,
    tryonDialog,
    policyRegulatory,
    StandardSpecification,
    PopularSearches,
    LatestAnswers,
    IntelligentAnswers,
    PuishmentDemo,
    DishonestyName,
    NoticePublicity
  },
  data() {
    return {
      computeImg: require('/assets/images/jfjsq.png'),
    }
  },
  computed: {
    imgList() {
      return [
        {
          url: require("@/assets/images/index/icon1.png"),
        },
        {
          url: require("@/assets/images/index/icon2.png"),
        },
        {
          url: require("@/assets/images/index/icon3.png"),
        },
        {
          url: require("@/assets/images/index/icon4.png"),
        },
        {
          url: require("@/assets/images/index/icon5.png"),
        },
        {
          url: require("@/assets/images/index/icon6.png"),
        },
      ];
    },
    toolList() {
      return [
        {
          title: "计费计算器",
          desc: "报告计费计算器",
          icon: require("@/assets/images/index/calc.png"),
          href: "/deal-nav/calculter",
          nodeid: "calculter",
          menuname: "计费计算器",
        },
        {
          title: "CA办理",
          desc: "各地CA办理快捷入口",
          icon: require("@/assets/images/index/ca.png"),
          href: "/deal-nav/cabl",
          nodeid: "ca",
          menuname: "CA办理",
        },
        {
          title: "第三方平台",
          desc: "第三方平台快捷入口",
          icon: require("@/assets/images/index/zhaob.png"),
          href: "/deal-nav/third",
          nodeid: "third",
          menuname: "第三方平台",
        },
        {
          title: "交易中心",
          desc: "公共资源交易平台快捷入口",
          icon: require("@/assets/images/index/common.png"),
          href: "/deal-nav/jyzx?province=河北省&city=石家庄市&activeName=jyzx",
          nodeid: "deal-nav",
          menuname: "交易中心",
        },
      ];
    },
  },
  mounted() {
    document.querySelector('.layout-default').style.backgroundColor = '#ffffff'
  },
  beforeDestroy() {
    document.querySelector('.layout-default').style.backgroundColor = '#f5f7fd'
  },
  created() {
    this.$store.dispatch("analysis/updateHits", {visitlocation: '首页'});
    this.$nextTick(() => {
      this.getYzHandle();
    });
  },
  methods: {
    async getYzHandle(){
      if (this.$refs.policyRef && this.$refs.policyRef.getData) {
        await this.$refs.policyRef.getData();
      }
      if (this.$refs.standardRef && this.$refs.standardRef.getData) {
        await this.$refs.standardRef.getData();
      }
    },
    // 采购文件编制登录
    getSedToken() {
      this.$store.dispatch("analysis/updateHits", {
        visitlocation: "招标采购文件编制",
      });
      this.$refs.tryon.checkUserState();
    },
    // 计费计算器
    jumpComputed() {
      this.$router.push({path: "/deal-nav/calculter"});
    },
  },
};
</script>

<style lang="scss" scoped>
.lookMore {
  margin-top: 27px;
  text-align: center;
  cursor: pointer;
  font-weight: 400;
  font-size: 14px;
  color: #333333;
}

.card-empty {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  font-weight: 400;
  font-size: 14px;
  color: #aaa;
  text-align: center;
  padding-top: 20px;
}

.indexBox {
  width: 1200px;
  margin: 0 auto;
  padding-top: 40px;

  .card-title {
    font-weight: bold;
    font-size: 18px;
    color: #333333;
    margin-bottom: 23px;

    position: relative;
    display: inline-block; // 关键：让元素宽度随内容收缩
    padding-bottom: 10px;

    &::after {
      content: "";
      position: absolute;
      bottom: 0;
      left: 0;
      width: calc(100% - 5px); // 总宽度减去边距
      height: 2px;
      background: linear-gradient(
          90deg,
          rgba(14, 78, 255, 0) 0%,
          #0e4eff 20%,
          #00c6ff 50%,
          #0e4eff 80%,
          rgba(14, 78, 255, 0) 100%
      );
      background-size: 200% auto;
      //animation: shine 3s linear infinite;
      animation: shine 3s linear 2;
      border-radius: 3px;
    }
  }

  @keyframes shine {
    0% {
      background-position: 0 center;
    }
    100% {
      background-position: -200% center;
    }
  }

  .index-top {
    display: flex;
    justify-content: space-between;

    .top-left {
      width: 776px;
      background: #F0F5FD;
      border-radius: 10px;
      display: flex;
      justify-content: space-between;
      padding: 23px 18px 20px 18px;

      .top-item {
        width: 360px;
        position: relative;

        .card-option {
          position: absolute;
          top: -4px;
          right: 0;
          width: 245px;
        }
      }
    }

    .top-right {
      box-sizing: border-box;
      width: 403px;
      background: #F0F5FD;
      border-radius: 10px;
      display: flex;
      justify-content: space-between;
      padding: 23px 18px 20px 18px;
      cursor: pointer;
      overflow: hidden;


      img {
        width: 100%;
      }
    }
  }

  .index-question {
    display: flex;
    margin-top: 27px;

    .question-item {
      width: 386px;
      background: #FFFFFF;
      box-shadow: 0 0 12px 0 rgba(0, 0, 0, 0.1);
      padding-top: 19px;

      &:nth-of-type(2) {
        margin: 0 21px;
      }

      .question-title {
        font-weight: 400;
        font-size: 18px;
        color: #333333;
        padding: 0 30px 21px 30px;
        border-bottom: 1px solid #F2F2F2;

        img {
          margin-right: 12px;
        }

        display: flex;
        align-items: center;
      }

      .question-content {
        height: 366px;
      }
    }
  }

  .index-center {
    display: flex;
    justify-content: space-between;
    margin-top: 30px;
    height: 470px;

    .center-inline {
      width: 100%;
      background: #F0F5FD;
      border-radius: 10px;
      display: flex;
      justify-content: space-between;
      padding: 23px 18px 20px 18px;

      .center-item {
        position: relative;
        width: 100%;

        .card-content {
          height: 426px;
        }
      }
    }

    .center-left {
      width: 590px;
      background: #F0F5FD;
      border-radius: 10px;
      display: flex;
      justify-content: space-between;
      padding: 23px 18px 20px 18px;

      .center-item {
        position: relative;
        width: 100%;

        .card-content {
          height: 426px;
        }
      }
    }

    .center-right {
      width: 590px;
      background: #F0F5FD;
      border-radius: 10px;
      display: flex;
      justify-content: space-between;
      padding: 23px 18px 20px 18px;

      .center-item {
        width: 100%;
      }

      .card-content {
        height: 426px;
      }
    }
  }
}

.modelBox {
  width: 1200px;
  height: 208px;
  background: #fff url("../assets/images/index/zcBg.png") no-repeat 100% 100%;
  margin-top: 20px;
  box-shadow: 0 0 12px 0 rgba(0, 0, 0, 0.1);
}

.modelLeft {
  width: 352px;
  padding: 27px 35px 37px 35px;
}

.modelTitle {
  font-size: 20px;
  color: #1c1c1c;
  font-weight: bold;
}

.modelDesc {
  font-size: 18px;
  color: #1c1c1c;
  margin-top: 17px;
}

.nowUse {
  width: 182px;
  height: 46px;
  background-color: #0e4eff;
  margin-top: 28px;
  text-align: center;
  color: #fff;
  border-radius: 28px;
  line-height: 46px;
  font-size: 18px;
  cursor: pointer;
}

.modelRight {
  width: 848px;
  display: flex;
  justify-content: space-between;
  padding: 24px 15px;
}

.modelRight img {
  width: 119px;
  height: 161px;
  box-shadow: 0 0 8px 0 rgba(0, 0, 0, 0.12);
}
</style>
